import { createFormState } from "redux-freeform";

const formConfig = {
  searchTerm: {
    validators: [],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
